import { Box, BoxProps } from '@mui/material';
import { ResizeDirection } from 'hooks/common/useResizeHelpers';
import React from 'react';

type ResizableContainerBorderRenderedProps = {
  isResizable?: boolean;
  startResize: (
    direction: ResizeDirection,
    event: React.MouseEvent<Element, MouseEvent>
  ) => void;
} & BoxProps;

function ResizableContainerBorderRendered({
  isResizable = true,
  startResize,
}: ResizableContainerBorderRenderedProps) {
  if (!isResizable) return null;

  const borders = ['top', 'right', 'bottom', 'left'] as const;
  return (
    <>
      {borders.map((border) => (
        <Box
          key={border}
          onMouseDown={(e) => startResize(border, e)}
          sx={{
            position: 'absolute',
            bgcolor: 'red',
            height: '10px',
            zIndex: 200,
            ...(border === 'top' && {
              top: 0,
              left: 0,
              right: 0,
              height: '3px',
              cursor: 'ns-resize',
            }),
            ...(border === 'bottom' && {
              bottom: 0,
              left: 0,
              right: 0,
              height: '3px',
              cursor: 'ns-resize',
            }),
            ...(border === 'left' && {
              top: 0,
              bottom: 0,
              left: 0,
              width: '3px',
              height: '100%',
              cursor: 'ew-resize',
            }),
            ...(border === 'right' && {
              top: 0,
              bottom: 0,
              right: 0,
              width: '3px',
              cursor: 'ew-resize',
              height: '100%',
            }),
            backgroundColor: 'transparent',

            // '&:hover': {
            //   backgroundColor: (theme) => theme.palette.primary.light,
            // },
          }}
        />
      ))}
    </>
  );
}

export default ResizableContainerBorderRendered;
